module.exports = __webpack_public_path__ + "static/media/Eversourcelogo_color.aed91e50.svg";